import flatten from "lodash/flatten";
import PropTypes from "prop-types";
import * as React from "react";
import Graph from "react-graph-vis";

import "./index.css";

const BASE_SIZE = 100;
const SIZE_PER_CONNECTION = 20;

export default class ConnectionsGraph extends React.Component {
    static propTypes = {
        users: PropTypes.array
    };
    getGraph() {
        const { users } = this.props;
        const incomingConnectionsPerUser = {};
        users.forEach(user => {
            if (user.connections) {
                user.connections.forEach(connectedUserId => {
                    incomingConnectionsPerUser[connectedUserId] =
                        (incomingConnectionsPerUser[connectedUserId] || 0) + 1;
                });
            }
        });
        return {
            nodes: users.map(user => ({
                id: user.id,
                shape: "circularImage",
                // shapeProperties: {
                value:
                    BASE_SIZE +
                    SIZE_PER_CONNECTION *
                        (incomingConnectionsPerUser[user.id] || 0),
                // },
                image: user.photoURL,
                label: user.name
            })),
            edges: flatten(
                users.map(
                    user =>
                        user.connections
                            ? user.connections.map(connectedUserId => ({
                                  from: user.id,
                                  to: connectedUserId,
                                  length: 500,
                                  physics: false
                              }))
                            : []
                )
            )
        };
    }
    getOptions() {
        return {
            interaction: {
                dragNodes: false,
                selectConnectedEdges: false
            }
        };
    }
    render() {
        return Array.isArray(this.props.users) ? (
            <Graph graph={this.getGraph()} options={this.getOptions()} />
        ) : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/ConnectionsGraph/index.js